
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 5a5 5 0 015-5h50a5 5 0 015 5v30a5 5 0 01-5 5H5a5 5 0 01-5-5V5z","fill":"#888"}}),_c('rect',{attrs:{"x":"6","y":"30","width":"11","height":"4","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"19","y":"30","width":"10","height":"4","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"31","y":"30","width":"10","height":"4","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"43","y":"30","width":"11","height":"4","rx":"1","fill":"#fff"}}),_c('rect',{attrs:{"x":"43","y":"5","width":"11","height":"7","rx":"1","fill":"#C4C4C4"}})])
          )
        }
      }
    